import { all } from "redux-saga/effects";
import authSagas from "../modules/auth/saga";
import profileSagas from "../modules/profile/saga";
import companySagas from "../modules/company/pages/company/saga";
import productSagas from "../modules/company/pages/product/saga";
import customerProductSagas from "../modules/company/pages/customer/saga";
import overheadSagas from "../modules/company/pages/overhead/saga";
import saleSagas from "../modules/company/pages/sales-forecast/saga";
import financialModelSagas from "../modules/company/pages/financial-model/saga";
import userSagas from "../modules/user/saga";

export default function* rootSaga() {
  yield all([
    ...authSagas,
    ...profileSagas,
    ...companySagas,
    ...customerProductSagas,
    ...productSagas,
    ...overheadSagas,
    ...saleSagas,
    ...userSagas,
    ...financialModelSagas
  ]);
}



// WEBPACK FOOTER //
// ./src/store/sagas.js